// // export default SingleProductDetail;
// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router';
// import { useMain } from '../hooks/useMain';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard2 from 'src/components/shared/DashboardCard2';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import {
//     Box,
//     Typography,
//     Divider,
//     Tabs,
//     Tab,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
//     Button,
//     Chip
// } from '@mui/material';
// import { changeDateFormate } from 'src/utils/dateutils';

// const SingleProductDetail = () => {
//     const { singleProductId } = useParams();
//     const [data, setData] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
//     const [activeTab, setActiveTab] = useState(0);
//     const [dialogContentType, setDialogContentType] = useState('add');

//     const {
//         setShowMessage,
//         activeBranchId,
//         fetchConsumeProductById,
//     } = useMain();

//     const getData = async (singleProductId) => {
//         try {
//             setLoading(true);
//             const res = await fetchConsumeProductById(singleProductId, activeBranchId);
//             if (res.statusCode === 200) {
//                 setData(res.data);
//             } else {
//                 setShowMessage({ message: 'Failed to fetch product details', messageType: 'error' });
//             }
//         } catch (error) {
//             setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (singleProductId) getData(singleProductId);
//         return () => {
//             setData({});
//         };
//     }, [singleProductId, activeBranchId]);

//     const handleOpenHistoryDialog = (type) => {
//         setDialogContentType(type);
//         setOpenHistoryDialog(true);
//     };

//     const handleCloseHistoryDialog = () => {
//         setOpenHistoryDialog(false);
//     };

//     const handleTabChange = (event, newValue) => {
//         setActiveTab(newValue);
//     };

//     const renderAddHistoryTable = () => (
//         <TableContainer component={Paper} style={{ width: '60%' }}>
//             <Table size="small">
//                 <TableHead>
//                     <TableRow>
//                         <TableCell sx={{ paddingRight: '8px' }}>Date</TableCell>
//                         <TableCell align="center" sx={{ paddingLeft: '8px' }}>Count Added</TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {data?.addedOn?.map((item, index) => (
//                         <TableRow key={index}>
//                             <TableCell sx={{ paddingRight: '8px' }}>{changeDateFormate(item.dateOfAddingConsumeableProduct)}</TableCell>
//                             <TableCell align="center" sx={{ paddingLeft: '8px' }}>{item.consumeableProductAddedCount}</TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );

//     const renderConsumptionHistoryTable = () => (
//         <TableContainer component={Paper}>
//             <Table size="small">
//                 <TableHead>
//                     <TableRow>
//                         <TableCell>Date</TableCell>
//                         <TableCell align="right">Volume Used</TableCell>
//                         <TableCell>Type</TableCell>
//                         <TableCell>Service</TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {data?.consumptionHistory?.map((item, index) => (
//                         <TableRow key={index}>
//                             <TableCell>{changeDateFormate(item.dateOfConsumption)}</TableCell>
//                             <TableCell align="right">
//                                 {item.consumptionAmount} {item.consumptionAmountUnit || data.productUnit}
//                             </TableCell>
//                             <TableCell>
//                                 <Chip 
//                                     label={item.consumptionType || 'N/A'} 
//                                     color={
//                                         item.consumptionType === 'Updated Product' ? 'primary' : 
//                                         item.consumptionType === 'Service Usage' ? 'secondary' : 
//                                         'default'
//                                     }
//                                     variant="outlined"
//                                     size="small"
//                                 />
//                             </TableCell>
//                             <TableCell>{item.serviceName || 'N/A'}</TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );

//     return (
//         <PageContainer title="Product Details" description="this is Product Details Page">
//             <DashboardCard2 title="Product Details">
//                 {loading ? (
//                     <ShowLoader />
//                 ) : Object.keys(data).length > 0 ? (
//                     <>
//                         <div className="client-container">
//                             <div className="client-header">
//                                 <div className="profile-img"></div>
//                                 <div>
//                                     <p className="client-text">Product Name</p>
//                                     <h6 className="client-bold-title">{data?.consumeableProductName}</h6>
//                                 </div>
//                             </div>

//                             <div className="row">
//                                 <div className="col-6">
//                                     <div className="client-body">
//                                         <p className="client-text">Volume</p>
//                                         <h6 className="client-title">{data?.productVolume} {data?.productUnit}</h6>
//                                     </div>

//                                     <div className="client-body">
//                                         <p className="client-text">Available Count</p>
//                                         <h6 className="client-title">{data?.consumeableProductCount}</h6>
//                                     </div>
//                                 </div>

//                                 <div className="col-6">
//                                     <div className="client-body">
//                                         <p className="client-text">Remaining Volume</p>
//                                         <h6 className="client-title">{data?.remainingProductVolume} {data?.remainingProductUnit}</h6>
//                                     </div>
//                                 </div>
//                             </div>

//                             <Box sx={{ mt: 4 }}>
//                                 <Tabs value={activeTab} onChange={handleTabChange} centered>
//                                     <Tab label="Add Count History" />
//                                     <Tab label="Consumption History" />
//                                 </Tabs>

//                                 {activeTab === 0 && (
//                                     <Box sx={{ mt: 2 }}>
//                                         <Box sx={{ width: '50%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                                             <Typography variant="subtitle1">
//                                                 Product Addition History ({data?.addedOn?.length || 0} entries)
//                                             </Typography>
//                                         </Box>
//                                         <Divider />

//                                         {(!data?.addedOn || data.addedOn.length === 0) ? (
//                                             <Typography sx={{ mt: 2, color: 'text.secondary' }}>No add history available</Typography>
//                                         ) : (
//                                             <Box sx={{ mt: 2 }}>
//                                                 {renderAddHistoryTable()}
//                                             </Box>
//                                         )}
//                                     </Box>
//                                 )}

//                                 {activeTab === 1 && (
//                                     <Box sx={{ mt: 2 }}>
//                                         <Box sx={{ width: '50%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                                             <Typography variant="subtitle1">
//                                                 Product Usage History ({data?.consumptionHistory?.length || 0} entries)
//                                             </Typography>
//                                         </Box>
//                                         <Divider />

//                                         {(!data?.consumptionHistory || data.consumptionHistory.length === 0) ? (
//                                             <Typography sx={{ mt: 2, color: 'text.secondary' }}>No consumption history available</Typography>
//                                         ) : (
//                                             <Box sx={{ mt: 2 }}>
//                                                 {renderConsumptionHistoryTable()}
//                                             </Box>
//                                         )}
//                                     </Box>
//                                 )}
//                             </Box>
//                         </div>

//                         <Dialog
//                             open={openHistoryDialog}
//                             onClose={handleCloseHistoryDialog}
//                             maxWidth="md"
//                             fullWidth
//                             sx={{
//                                 '& .MuiDialog-paper': {
//                                     maxHeight: '70vh'
//                                 }
//                             }}
//                         >
//                             <DialogTitle>
//                                 {dialogContentType === 'add' ? 'Product Addition History' : 'Product Consumption History'}
//                             </DialogTitle>
//                             <DialogContent dividers>
//                                 {dialogContentType === 'add' ? (
//                                     data?.addedOn?.length > 0 ? (
//                                         renderAddHistoryTable()
//                                     ) : (
//                                         <Typography sx={{ py: 2, textAlign: 'center' }}>No add history available</Typography>
//                                     )
//                                 ) : data?.consumptionHistory?.length > 0 ? (
//                                     renderConsumptionHistoryTable()
//                                 ) : (
//                                     <Typography sx={{ py: 2, textAlign: 'center' }}>No consumption history available</Typography>
//                                 )}
//                             </DialogContent>
//                             <DialogActions>
//                                 <Button onClick={handleCloseHistoryDialog}>Close</Button>
//                             </DialogActions>
//                         </Dialog>
//                     </>
//                 ) : (
//                     <Typography sx={{ py: 2, textAlign: 'center' }}>No product data found</Typography>
//                 )}
//             </DashboardCard2>
//         </PageContainer>
//     );
// };

// export default SingleProductDetail;

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useMain } from '../hooks/useMain';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import {
    Box,
    Typography,
    Divider,
    Tabs,
    Tab,
    Chip,
} from '@mui/material';
import { changeDateFormate } from 'src/utils/dateutils';
import { MdDelete } from 'react-icons/md';

const SingleProductDetail = () => {
    const { singleProductId } = useParams();
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [dialogContentType, setDialogContentType] = useState('add');

    const {
        setShowMessage,
        activeBranchId,
        fetchConsumeProductById,
    } = useMain();

    const getData = async (singleProductId) => {
        try {
            setLoading(true);
            const res = await fetchConsumeProductById(singleProductId, activeBranchId);
            if (res.statusCode === 200) {
                setData(res.data);
            } else {
                setShowMessage({ message: 'Failed to fetch product details', messageType: 'error' });
            }
        } catch (error) {
            setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (singleProductId) getData(singleProductId);
        return () => {
            setData({});
        };
    }, [singleProductId, activeBranchId]);
    
    console.log(data,'dataaa')

    const handleOpenHistoryDialog = (type) => {
        setDialogContentType(type);
        setOpenHistoryDialog(true);
    };

    const handleCloseHistoryDialog = () => {
        setOpenHistoryDialog(false);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const renderAddHistoryTable = () => (
        <Box sx={{ overflow: 'auto', width: '100%', mt: 2 }}>
            <table className="table-container" style={{ width: '100%', tableLayout: 'fixed' }}>
                <thead className="table-thead">
                    <tr>
                        <th style={{ width: '150px', padding: '8px' }}>Date</th>
                        <th style={{ width: '100px', padding: '8px' }}>Count Added</th>
                        {/* <th style={{ width: '80px', padding: '8px' }}>Actions</th> */}
                    </tr>
                </thead>
                <tbody className="table-tbody">
                    {data?.addedOn?.map((item, index) => (
                        <tr key={index}>
                            <td style={{ width: '150px', padding: '8px' }}>
                                {changeDateFormate(item.dateOfAddingConsumeableProduct)}
                            </td>
                            <td style={{ width: '100px', padding: '8px', textAlign: 'center' }}>
                                {item.consumeableProductAddedCount}
                            </td>
                            {/* <td style={{ width: '80px', padding: '8px' }}>
                                <IconButton size="small" color="error">
                                    <MdDelete />
                                </IconButton>
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </table>
        </Box>
    );

    const renderConsumptionHistoryTable = () => (
        <Box sx={{ overflow: 'auto', width: '100%', mt: 2 }}>
            <table className="table-container" style={{ width: '100%', tableLayout: 'fixed' }}>
                <thead className="table-thead">
                    <tr>
                        <th style={{ width: '150px', padding: '8px' }}>Date</th>
                        <th style={{ width: '100px', padding: '8px' }}>Volume Used</th>
                        <th style={{ width: '170px', padding: '8px' }}>Type</th>
                        <th style={{ width: '150px', padding: '8px' }}>Service</th>
                        <th style={{ width: '150px', padding: '8px' }}>Service Provider</th>
                        {/* <th style={{ width: '80px', padding: '8px' }}>Actions</th> */}
                    </tr>
                </thead>
                <tbody className="table-tbody">
                    {data?.consumptionHistory?.map((item, index) => (
                        <tr key={index}>
                            <td style={{ width: '150px', padding: '8px' }}>
                                {changeDateFormate(item.dateOfConsumption)}
                            </td>
                            <td style={{ width: '100px', padding: '8px' }}>
                                {item.consumptionAmount} {item.consumptionAmountUnit || data.productUnit}
                            </td>
                            <td style={{ width: '170px', padding: '8px' }}>
                                <Chip 
                                    label={`${item.consumptionType}` || 'N/A'} 
                                    color={
                                        item.consumptionType === 'Updated Product' ? 'primary' : 
                                        item.consumptionType === 'Service Usage' ? 'secondary' : 
                                        'default'
                                    }
                                    variant="outlined"
                                    size="small"
                                />
                            </td>
                            <td style={{ width: '150px', padding: '8px' }}>
                                {item?.consumptionServiceId?.serviceName || 'N/A'}
                            </td>
                            {/* <td style={{ width: '80px', padding: '8px' }}>
                                <IconButton size="small" color="error">
                                    <MdDelete />
                                </IconButton>
                            </td> */}
                               <td style={{ width: '150px', padding: '8px' }}>
                                {item?.consumptionServiceProviderId?.map((provider)  =>  provider.name).join(",") || 'N/A'}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Box>
    );
  

    return (
        <PageContainer title="Product Details" description="this is Product Details Page">
            <DashboardCard2 title="Product Details">
                {loading ? (
                    <ShowLoader />
                ) : Object.keys(data).length > 0 ? (
                    <>
                        <div className="client-container">
                            <div className="client-header">
                                <div className="profile-img"></div>
                                <div>
                                    <p className="client-text">Product Name</p>
                                    <h6 className="client-bold-title">{data?.consumeableProductName}</h6>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-6">
                                    <div className="client-body">
                                        <p className="client-text">Volume</p>
                                        <h6 className="client-title">{data?.productVolume} {data?.productUnit}</h6>
                                    </div>

                                    <div className="client-body">
                                        <p className="client-text">Available Count</p>
                                        <h6 className="client-title">{data?.consumeableProductCount}</h6>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="client-body">
                                        <p className="client-text">Remaining Volume</p>
                                        <h6 className="client-title">{data?.remainingProductVolume} {data?.remainingProductUnit}</h6>
                                    </div>
                                </div>
                            </div>

                            <Box sx={{ mt: 4 }}>
                                <Tabs value={activeTab} onChange={handleTabChange} centered>
                                    <Tab label="Add Count History" />
                                    <Tab label="Consumption History" />
                                </Tabs>

                                {activeTab === 0 && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="subtitle1" sx={{ mb: 2 }}>
                                            Product Addition History ({data?.addedOn?.length || 0} entries)
                                        </Typography>
                                        <Divider />

                                        {(!data?.addedOn || data.addedOn.length === 0) ? (
                                            <Typography sx={{ mt: 2, color: 'text.secondary' }}>No add history available</Typography>
                                        ) : (
                                            renderAddHistoryTable()
                                        )}
                                    </Box>
                                )}

                                {activeTab === 1 && (
                                    <Box sx={{ mt: 2 }}>
                                        <Typography variant="subtitle1" sx={{ mb: 2 }}>
                                            Product Usage History ({data?.consumptionHistory?.length || 0} entries)
                                        </Typography>
                                        <Divider />

                                        {(!data?.consumptionHistory || data.consumptionHistory.length === 0) ? (
                                            <Typography sx={{ mt: 2, color: 'text.secondary' }}>No consumption history available</Typography>
                                        ) : (
                                            renderConsumptionHistoryTable()
                                        )}
                                    </Box>
                                )}
                            </Box>
                        </div>
                    </>
                ) : (
                    <Typography sx={{ py: 2, textAlign: 'center' }}>No product data found</Typography>
                )}
            </DashboardCard2>
        </PageContainer>
    );
};

export default SingleProductDetail;